<!-- The Modal -->
<div id="feedback__Modal" class="feedback__modal progress__modal" style="display: flex;">
    <!-- Modal content -->
    <div class="modal-content">
        <div class="popup--close">
            <button (click)="hideModal()"><span class="icon-cross"></span></button>
        </div>
        <div class="feedback__Modal--topsection">

            <img src="assets/images/smiley.svg" alt="">
            <ng-container>
                <p class="feedback__Modal--coursename">This is a recommended task and doesn't count towards your program completion. Would you like to Skip or Start?</p>
            </ng-container>
        </div>
        <div class="bottom">
                <button class="btn btn-primary" (click)="skipCurrentItem()">Skip</button>
                <button class="btn btn-primary" (click)="startCurrentItemEvent()">Start</button>
            </div>
    </div>
</div>